<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modal" hide-footer title="Lease term - new">
        <div class="d-block">
        <form v-on:submit.prevent="createNew">

            <div class="form-group">
                <label for="term">Term</label>
                <input type="number" 
                class="form-control" 
                id="term" 
                placeholder="Term"
                v-model="term">
                <div class="invalid-feedback" v-if="errors.term">{{ errors.term[0] }}</div>
            </div>
            <div class="form-group">
                <label for="rvRate">RV rate</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="rvRate" 
                placeholder="RV rate"
                v-model="rvRate">
                <div class="invalid-feedback" v-if="errors.rvRate">{{ errors.rvRate[0] }}</div>
            </div>
        <hr>
        <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button type="submit" class="btn btn-primary btn-sm">Save</button>
        </div>
        </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as leaseTermService from '../../services/leaseTerm.service';
    export default {
        name:"ModalLeaseTermNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                term:'',
                rvRate:'',
            }
        },
        methods:{
            ...mapActions(['fetchLeaseTermAll']),
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            createNew:async function(){
                const formData = new FormData();
                formData.append('term',this.term);
                formData.append('rvRate',this.rvRate);
            try{
                await leaseTermService.add(formData);
                this.hideModal();
                this.fetchLeaseTermAll();

                messageService.fnSweetAlertSuccessToast('Lease term - new', 'Added successfully');

                this.term = '';
                this.rvRate = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Lease term - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Lease term - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>